import { useEffect } from 'react';
import cn from 'classnames';
import { ELEMENT_SIZE, Icon, InputField, Panel, SelectField } from 'ht-styleguide';
import QuantitySelector from './QuantitySelector';
import styles from '../selectors.module.scss';
import { TDropdown } from '@scenes/HomeHub/homehub.types';

const DeviceDropdownSelector = ({
  options,
  value,
  showCloseIcon,
  canCloseDevice,
  gridColumn = 2,
  showDeviceInput,
  showModelInput,
  id,
  onDropdownChange,
  onQtyChange,
  onPanelIconClick,
  onInputIconClose,
  onInputChange,
}: TDropdown) => {
  const isIdkValue = value?.idk;

  const onQuantityChange = (qty: number) => onQtyChange(qty);
  const onCloseClick = (val: any) => {
    if (canCloseDevice) {
      onPanelIconClick(val);
    } else {
      onPanelIconClick(undefined);
    }
  };

  const dropdownOptions = options.map((o: any) => {
    const formattedOptions = { label: o.make_name, value: o.make_id };
    return formattedOptions;
  });
  const models = options.find(option => option.make_id === value?.make_id);
  const deviceModelOptions = models?.models.map((model: any) => ({ label: model.model_name, value: model.model_id }));
  const panelStyles = cn(styles.dropdownPanel, {
    [styles.allSelected]: value?.make_name?.trim() && (value?.model_name?.trim() || isIdkValue),
    [styles.grid1]: gridColumn === 1,
    [styles.grid2]: gridColumn === 2,
    [styles.grid3]: gridColumn === 3,
  });

  useEffect(() => {
    const makeInput = document.getElementById(`makeInput-${id}`);
    const modelInput = document.getElementById(`modelInput-${id}`);
    if (showDeviceInput && makeInput !== null) {
      makeInput.focus();
    }
    if (!makeInput && showModelInput && modelInput !== null) {
      modelInput.focus();
    }
  }, [showDeviceInput, showModelInput, id]);

  return (
    <Panel noShadow largeBorderRadius className={panelStyles}>
      {(showCloseIcon || !!value?.make_id) && <Icon name="round-x-fill" className={styles.closeIcon} onClick={() => onCloseClick(value)} />}
      <div className={styles.row}>
        <div className={styles.dropdownColumn}>
          {!showDeviceInput && (
            <SelectField
              elementSize={ELEMENT_SIZE.S}
              onChange={v => onDropdownChange(v, 'make')}
              options={dropdownOptions}
              value={value?.make_id || ''}
              className={styles.dropdown}
              placeholder="Select a Brand"
              reactSelectClassName="text-align-left"
              searchable
            />
          )}
          {showDeviceInput && (
            <InputField
              id={`makeInput-${id}`}
              elementSize={ELEMENT_SIZE.S}
              inputWrapperClass="marginBottom-small"
              iconName="close"
              iconOnClick={() => onInputIconClose('make')}
              onChange={e => onInputChange('make', e.target.value)}
              value={value?.make_name as string}
              iconClass={styles.closeInputIcon}
              autoFocus={showDeviceInput}
              placeholder="Enter device brand"
            />
          )}
          {!showModelInput && (
            <SelectField
              onChange={v => onDropdownChange(v, 'model')}
              options={deviceModelOptions}
              value={value?.model_id || ''}
              className={styles.dropdown}
              isDisabled={!value?.make_id || isIdkValue}
              placeholder="Select a Device"
              elementSize={ELEMENT_SIZE.S}
              reactSelectClassName="text-align-left"
              searchable
            />
          )}

          {showModelInput && (
            <InputField
              id={`modelInput-${id}`}
              elementSize={ELEMENT_SIZE.S}
              iconName={value?.make_id === 'other' ? '' : 'close'}
              value={value?.model_name as string}
              iconOnClick={() => onInputIconClose('model')}
              onChange={e => onInputChange('model', e.target.value)}
              disabled={!value?.make_id}
              iconClass={styles.closeInputIcon}
              autoFocus={!showDeviceInput && showModelInput}
              placeholder="Enter device model"
            />
          )}
        </div>
        <div className={styles.qtySelectorColumn}>
          <QuantitySelector onClick={onQuantityChange} quantity={value?.qty} />
        </div>
      </div>
    </Panel>
  );
};

export default DeviceDropdownSelector;
